module.exports = __webpack_public_path__ + "img/wallet-fill.0efc056e.svg";